import script from "./MissingProfileRequirementsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MissingProfileRequirementsModal.vue?vue&type=script&setup=true&lang=js"

import "./MissingProfileRequirementsModal.vue?vue&type=style&index=0&id=05d32bcc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05d32bcc"]])

export default __exports__